import { useState } from "react";
import type { InventoryContent } from "./types";

export function BlankInventoryDownload({ content }: { content: InventoryContent }) {
  const [preparing, setPreparing] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");

  async function download() {
    setPreparing(true);
    setError("");
    setNotice("");
    try {
      const { createBlankInventoryPdf, BLANK_INVENTORY_FILENAME } = await import("./blankInventoryPdf");
      const bytes = await createBlankInventoryPdf(content);
      const url = URL.createObjectURL(new Blob([new Uint8Array(bytes)], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      link.download = BLANK_INVENTORY_FILENAME;
      document.body.appendChild(link);
      try {
        link.click();
        setNotice("PDF ready. Check your browser's downloads.");
      } finally {
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 30_000);
      }
    } catch {
      setError("The blank PDF could not be prepared. Please try again.");
    } finally {
      setPreparing(false);
    }
  }

  return <div className="blank-inventory-download">
    <button type="button" className="button secondary" disabled={preparing} onClick={() => void download()}>{preparing ? "Preparing PDF..." : "Download blank Inventory PDF"}</button>
    {error ? <p role="alert">{error}</p> : <p role="status">{notice || "US Letter · All questions with space to write"}</p>}
  </div>;
}
